// libs
import { useState, useEffect, useCallback } from 'react';

// helpers
import { validateEmail } from 'shared/helpers/utils';

// constants
import { getEmailInSessionStorage, setEmailInSessionStorage } from '../helpers/emailHelpers';
// defs
interface INotifyApiProps {
  customerEmail: string;
  productId: string;
  onNotified?: Function;
  showToastMessage?: boolean;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const useNotifyApi = ({
  customerEmail,
  productId,
  onNotified = EMPTY_FUNC,
}: INotifyApiProps) => {
  const [isErrorInEmail, setIsErrorInEmail] = useState(false);
  const [isApiSuccess, setApiSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [inProgress, setInProgress] = useState(false);
  const [apiFailure, setApiFailure] = useState<boolean>(false);

  useEffect(() => {
    if (customerEmail.length > 0) {
      setUserEmail(customerEmail);
      return;
    }

    const email = getEmailInSessionStorage();
    if (email && email.length > 0) {
      setUserEmail(email);
      return;
    }
  }, [customerEmail, setUserEmail]);

  const reset = useCallback(() => {
    setApiSuccess(false);
    setIsErrorInEmail(false);
    setApiFailure(false);
  }, []);

  useEffect(() => {
    reset();
  }, [productId, reset]);

  const onNotifyClick = async () => {
    if (isApiSuccess) {
      return;
    }

    const isEmailValid = validateEmail(userEmail);
    if (isEmailValid) {
      setIsErrorInEmail(false);
      setInProgress(true);
      setApiSuccess(true);
      setEmailInSessionStorage(userEmail);
      onNotified({
        email: userEmail,
      });
      setInProgress(false);
    } else {
      setIsErrorInEmail(true);
    }
  };

  return {
    setUserEmail,
    onNotifyClick,
    userEmail,
    isErrorInEmail,
    isApiSuccess,
    inProgress,
    validEmail: validateEmail(userEmail),
    apiFailure,
    reset,
  };
};

export default useNotifyApi;
